import { Link } from '@backstage/ui';
import type { HeaderBreadcrumb } from '@backstage/ui';
import { RiArrowLeftLongLine } from '@remixicon/react';
import styles from './DocsBackLink.module.css';

export function DocsBackLink({ to }: { to: HeaderBreadcrumb }) {
  return (
    <Link
      href={to.href}
      standalone
      color="secondary"
      className={styles.backLink}
    >
      <RiArrowLeftLongLine size={16} aria-hidden="true" />
      {`Back to ${to.label}`}
    </Link>
  );
}
